module.exports = __webpack_public_path__ + "media/images/page-title-bk-779cb055fc4a9fe019d19725aaa405e5.jpg";